import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import {
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  DataListModel,
  WeGoAuthorizedLink,
  Permission,
  PermissionType,
} from '../../shared/config';
import { ErrorEscalationService } from '../models/errorescalation.service';
import { ErrorEscalationModel } from '../models/errorescalation.model';
import { DropdownModel } from '../../report/models/report-filter.model';
import { ModalDirective } from 'ng2-bootstrap/components/modal';

@Component({
  selector: 'error-escalation',
  template: require('../views/errorescalation-list.component.html'),
  providers: [ErrorEscalationService],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    `
  ]
})
export class ErrorEscalationComponent implements OnInit {
  DataListModel: DataListModel;
  errorEscalationList: ErrorEscalationModel[] = [];
  apiErrorMsg: string;
  isLoading: boolean;
  message: string;
  urlDefaultPage: string;
  private popupMsg: string;
  private module: string;
  public breadCrumbList: string;
  pageName: string;
  apiResponse: IAPIResponse;
  model: ErrorEscalationModel;
  addErrorEscalationConfigLink:string;
  public errorEscalationHashId : string;
  private popupTitle: string;
  private validationMessage: string;
  urlErrorEsclationUpdate : string;
  @ViewChild('confirmModal') public confirmModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('alertModal') public alertModal: ModalDirective;
  
  constructor(
    private errorescalationService: ErrorEscalationService,
    private authService: AuthService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.model = new ErrorEscalationModel();
    this.pageName = 'Error_Escalation';
    this.module = this.translate.instant('LblErrorEscalation');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.addErrorEscalationConfigLink = this.authService.GetURL(ApplicationRouteURL.URL_ERROR_ESCALATION_ADD);
    this.DataListModel.searchField = [
      'customerName',
      'instanceName',
      'componentName',
      'logType'
    ];
    this.urlErrorEsclationUpdate = this.authService.GetURL(ApplicationRouteURL.URL_ERROR_ESCALATION_UPDATE);
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.GetErrorEscalationList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetErrorEscalationList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetErrorEscalationList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetErrorEscalationList();
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetErrorEscalationList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.errorescalationService
      .ExportErrorEscalation(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res) {
            let fileName = 'ErrorEscalation' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ShowConfirmModal(errorEscalationHashId?: string): void {
    this.errorEscalationHashId = errorEscalationHashId;
    this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.confirmModal.show();
  }
  
  public HideConfirmModal(): void {
    this.errorEscalationHashId = "";
    this.confirmModal.hide();
  }

  public SuccessModalClick(): void {
    this.DeleteErrorEscalation(this.errorEscalationHashId);
    this.confirmModal.hide();
  }

  public DeleteErrorEscalation(deleteErrorEscalation: string) {
    this.isLoading = true;
    this.errorescalationService.DeleteErrorEscalation(deleteErrorEscalation)
      .subscribe(
      res => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetErrorEscalationList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.validationMessage = res.error;
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowAlertModal();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }
  public SuccessAlertModalClick(): void {
    this.alertModal.hide();
  }

  public ShowAlertModal(): void {
    this.isLoading = false;
    this.alertModal.show();
  }


  public GetErrorEscalationList() {
    this.isLoading = true;
    this.errorescalationService
      .GetErrorEscalationConfigList(this.model, this.DataListModel)
      .subscribe(
        res => {
          this.errorEscalationList = res.data;
          console.log(res.data);
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/errorescalation-configuration/components/errorescalation-list.component.ts